import { render, staticRenderFns } from "./Momo.vue?vue&type=template&id=2a15ac1a"
import script from "./Momo.vue?vue&type=script&lang=js"
export * from "./Momo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports